import { Component } from '@angular/core';

@Component({
    selector: 'app-virtual-route',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class VirtualRouteComponent {

  constructor() { }

}
